// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__ZKkD8","cardStyle":"Home_cardStyle__s+SH7"};